export const CookieConsentCategory = {
    FUNCTIONAL: "cookie_cat_functional",
    MARKETING: "cookie_cat_marketing",
    STATISTICS: "cookie_cat_statistic",
} as const;

export type CookieConsentCategory =
    (typeof CookieConsentCategory)[keyof typeof CookieConsentCategory];

export const CookieConsentStatus = {
    DENIED: "denied",
    GRANTED: "granted",
    PENDING: "pending",
} as const;

export type CookieConsentStatus = (typeof CookieConsentStatus)[keyof typeof CookieConsentStatus];

export const COOKIE_INFORMATION_API_READY_EVENT = "CookieInformationAPIReady";
export const COOKIE_INFORMATION_CONSENT_CHANGED_EVENT = "CookieInformationConsentGiven";

export const getCookieConsentStatus = (category: CookieConsentCategory): CookieConsentStatus => {
    if (
        typeof window === "undefined" ||
        !window.isCookieInformationAPIReady ||
        !window.CookieInformation
    ) {
        return CookieConsentStatus.PENDING;
    }

    const consentGiven = window.CookieInformation.getConsentGivenFor(category);

    if (consentGiven === true) {
        return CookieConsentStatus.GRANTED;
    }

    if (consentGiven === false) {
        return CookieConsentStatus.DENIED;
    }

    return CookieConsentStatus.PENDING;
};
